// extracted by mini-css-extract-plugin
export default {"highlightedText":"uWXIDHkHsGG4dtIFQoWD6w=="};